module.exports = __webpack_public_path__ + "static/img/19-2.779e750.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/19-2.jpg
// module id = y4lU
// module chunks = 0